var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"criteria-factor d-flex align-center"},[_c('FactorInput',{attrs:{"factor":_vm.factor.factor,"unitUuid":_vm.unitUuid}}),_c('span',{staticClass:"criteria-factor-label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }